<template>
  <v-card elevation="1">
    <v-card-subtitle>
      <span class="headline">Fare Addons</span>
    </v-card-subtitle>
    <v-card-text>
      <v-data-table
        hide-default-footer
        disable-pagination
        :headers="fareAddonHeaders"
        :items="items">
        <template v-slot:top>
          <v-dialog
            v-model="showFareAddonDialog"
            max-width="350px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" @click="createNewFareAddon">Add Fare Addon</v-btn>
            </template>
            <ValidationObserver
              :disabled="true"
              ref="fareAddon"
              v-slot="{ invalid, valid, errors }">
              <v-form v-model="fareAddonValid">
                <v-card>
                  <v-card-title>
                    <span class="headline">Fare Addons</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            rules="required"
                            name="Direction"
                            vid="fareAddonDirectionId"
                            v-slot="{ errors }">
                            <v-select
                              :error-messages="errors"
                              :items="directions"
                              item-text="name"
                              item-value="id"
                              label="Direction"
                              outlined
                              dense
                              v-model="editedFareAddonItem.directionId">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            rules="required"
                            name="Description"
                            vid="fareAddonDescription"
                            v-slot="{ errors }">
                            <v-text-field
                              v-model="editedFareAddonItem.description"
                              :error-messages="errors"
                              label="Description"
                              append-icon="mdi-card-bulleted-outline"
                              placeholder="Enter description">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            rules="required|min_value:1"
                            name="Addon Price"
                            vid="fareAddonPrice"
                            v-slot="{ errors }">
                            <v-currency-field
                              :error-messages="errors"
                              label="Addon Price"
                              v-model="editedFareAddonItem.addonPrice"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeFareAddon">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveFareAddon">
                      Done
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-dialog>
        </template>
        <template v-slot:item.description="{ item }">
            <div :class="fareAddonDeleteClass(item)">
              {{ item.description }}
            </div>
        </template>
        <template v-slot:item.directionId="{ item }">
            <div :class="fareAddonDeleteClass(item)">
              {{ item.directionId | toDirection }}
            </div>
        </template>
        <template v-slot:item.addonPrice="{ item }">
            <div :class="fareAddonDeleteClass(item)">
              {{ item.addonPrice | toCurrency }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="primary" v-if="!item.deleteFg">
            <v-icon
              small
              @click="editFareAddon(item)">
              mdi-pencil</v-icon>
            </v-btn>
          <v-btn icon color="red" v-if="!item.deleteFg">
            <v-icon
              small
              @click="deleteFareAddon(item)">
              mdi-eraser
            </v-icon>
          </v-btn>
          <v-btn icon color="green" v-if="!!item.deleteFg">
            <v-icon
              small
              @click="restoreFareAddon(item)">
              mdi-file-restore
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

setInteractionMode('eager');

extend('required', required);

export default {
  name: 'fareAddon',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    items: {
      type: Array,
    },
    directions: {
      type: Array,
    },
  },
  data: () => ({
    defaultFareAddonItem: {
      id: undefined,
      suburbId: undefined,
      directionId: undefined,
      description: undefined,
      addonPrice: undefined,
      deleteFg: false,
    },
    fareAddonHeaders: [
      { text: 'Description', value: 'description' },
      { text: 'Direction', value: 'directionId' },
      { text: 'Add-on Price', value: 'addonPrice' },
      { text: 'Actions', value: 'actions' },
    ],
    editedFareAddonIndex: -1,
    fareAddonValid: false,
    showFareAddonDialog: false,
    editedFareAddonItem: {},
  }),
  methods: {
    saveFareAddon() {
      this.$refs.fareAddon.validate().then((success) => {
        this.fareAddonValid = success;
        if (this.fareAddonValid) {
          this.showFareAddonDialog = false;
          if (this.editedFareAddonIndex === -1) {
            this.items.push(this.editedFareAddonItem);
          } else {
            Object.assign(this.items[this.editedFareAddonIndex], this.editedFareAddonItem);
          }

          this.clearEditFareAddonItem();
        }
      });
    },
    closeFareAddon() {
      this.editedFareAddonItem = Object.assign({}, this.defaultFareAddonItem);
      this.showFareAddonDialog = false;
    },
    createNewFareAddon() {
      this.editedFareAddonItem = Object.assign({}, this.defaultFareAddonItem);
      this.showFareAddonDialog = true;
    },
    clearEditFareAddonItem() {
      this.$nextTick(() => {
        this.editedFareAddonItem = Object.assign({}, this.defaultFareAddonItem);
        this.editedFareAddonIndex = -1;
      });
    },
    editFareAddon(item) {
      this.editedFareAddonIndex = this.items.indexOf(item);
      this.editedFareAddonItem = Object.assign({}, item);
      this.showFareAddonDialog = true;
    },
    deleteFareAddon(item) {
      const idx = this.items.indexOf(item);
      const modifiedItem = this.items[idx];
      modifiedItem.deleteFg = true;
      this.$set(this.items, idx, modifiedItem);
    },
    restoreFareAddon(item) {
      const idx = this.items.indexOf(item);
      const modifiedItem = this.items[idx];
      modifiedItem.deleteFg = false;
      this.$set(this.items, idx, modifiedItem);
    },
    fareAddonDeleteClass(item) {
      if (item.deleteFg) {
        return 'fareAddon-deleted';
      }
      return null;
    },
  },
};
</script>

<style>
  .fareAddon-deleted {
    color: #ff0000;
    text-decoration: line-through;
  }
</style>
